var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopysuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3499_8904",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 27C16.5761 27.0019 18.1371 26.6924 19.5933 26.0892C21.0495 25.4861 22.3721 24.6011 23.4852 23.4852C24.6011 22.3721 25.4861 21.0495 26.0892 19.5933C26.6924 18.1371 27.0019 16.5761 27 15C27.0019 13.4239 26.6924 11.8629 26.0892 10.4067C25.4861 8.95054 24.6011 7.62791 23.4852 6.51481C22.3721 5.3989 21.0495 4.51394 19.5933 3.91076C18.1371 3.30758 16.5761 2.99807 15 3.00001C13.4239 2.99807 11.8629 3.30758 10.4067 3.91076C8.95054 4.51394 7.62791 5.3989 6.51481 6.51481C5.3989 7.62791 4.51394 8.95054 3.91076 10.4067C3.30758 11.8629 2.99807 13.4239 3.00001 15C2.99807 16.5761 3.30758 18.1371 3.91076 19.5933C4.51394 21.0495 5.3989 22.3721 6.51481 23.4852C7.62791 24.6011 8.95054 25.4861 10.4067 26.0892C11.8629 26.6924 13.4239 27.0019 15 27Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2021 14.9965L13.8021 18.5965L21.0021 11.3965",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3499_8904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.587891 0.603516H29.3879V29.4035H0.587891V0.603516Z",
    fill: "#BFFFD9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopysuccess);
export default __webpack_public_path__ + "static/media/copy success.c3aefdaa05c7923bdd24a7f74ee1362a.svg";
export { ForwardRef as ReactComponent };